<template>
    <div class="role">
        <div class="role-top">
            <div class="role-Choice">
                <span>部门：</span>
                <el-select @change="selectChanged" v-model="value" placeholder="请选择">
                    <el-option
                        v-for="(item,index) in options"
                        :key="index"
                        :label="item.department"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </div>
            <div class="role-Choice">
                <span>部长：</span>
                <el-select @change="selectChangeds" v-model="valuess" filterable placeholder="请选择">
                    <el-option
                        v-for="(item,index) in soptions"
                        :key="index"
                        :label="item.role"
                        :value="item.did"
                    ></el-option>
                </el-select>
            </div>
            <div class="role-Choice">
                <span>组长：</span>
                <el-select
                    @change="selectChangedss"
                    v-model="valuesss"
                    filterable
                    placeholder="请选择"
                >
                    <el-option
                        v-for="(item,index) in soptionsr"
                        :key="index"
                        :label="item.role"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </div>
            <div class="role-Choice">
                <el-input
                    class="inline-input"
                    v-model="state"
                    placeholder="请搜索姓名或手机号"
                    :trigger-on-focus="false"
                >
                    <i class="el-icon-search el-input__icon" slot="suffix" @click="handleIconClick"></i>
                </el-input>
            </div>
        </div>
        <div class="role-content">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                border
                max-height="1000"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column fixed prop="name" label="姓名"></el-table-column>
                <el-table-column prop="telephone" label="手机号"></el-table-column>
                <el-table-column prop="date" sortable label="注册时间" width="170"></el-table-column>
                <el-table-column prop="entrydata" label="入职时间" sortable width="170"></el-table-column>
                <el-table-column prop="rdate" label="创建角色时间" sortable width="170"></el-table-column>
                <el-table-column prop="uname" label="角色"></el-table-column>
                <!-- <el-table-column prop="gname" label="组长"></el-table-column>
                <el-table-column prop="rname" label="员工"></el-table-column> -->
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="deleteRow(scope.$index, tableData)"
                            type="text"
                            size="small"
                        >编辑</el-button>
                        <el-button
                            @click.native.prevent="deleteRow(scope.$index, tableData)"
                            type="text"
                            size="small"
                        >移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                style="margin-top: 16px; text-align:right;"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 50, 100, 250]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: "role",
    data() {
        return {
            options: [],
            tableData: [],
            value: "",
            valuess: "",
            valuesss: "",
            state: "",
            total: 0,
            user: "",
            soptions: "",
            soptionsr: "",
            multipleSelection: "",
            pagesize: 10,
            currentpage: 1,
            users: "",
            did: "",
            drid: "",
            gid: ""
        };
    },
    mounted() {
        this.choice();
        this.init();
    },
    created() {
        this.users = JSON.parse(window.localStorage.getItem("user"));
    },
    methods: {
        // 下拉
        init() {
            this.$http
                .post(
                    "/api/userControllers/selectDepartmentCid?cid=" +
                        this.users.cid +
                        "&page=" +
                        this.currentpage +
                        "&size=" +
                        this.pagesize
                )
                .then(res => {
                    console.log(res.data);
                    this.tableData = res.data.data.list;
                    res.data.data.list.forEach(element => {
                        if (element.gname === "") {
                            element.gname = "--";
                        }
                        if (element.uname === "") {
                            element.uname = "--";
                        }
                        if (element.rname === "") {
                            element.rname = "--";
                        }
                    });
                    this.total = res.data.data.total;
                });
        },
        choice(val) {
            this.$http
                .post(
                    "/api/departmentController/selectDepartment?cid=" +
                        this.users.cid
                )
                .then(res => {
                    if (res.data.code === 200) {
                        this.options = res.data.data;
                    }
                });
        },
        selectChanged(val) {
            this.did = val;
            this.$http
                .post(
                    "/api/departmentController/selectDepartmentsRole?did=" + val
                )
                .then(res => {
                    if (res.data.code === 200) {
                        this.soptions = res.data.data;
                        console.log("1");
                        this.selectDepartmentRoleDis(val);
                    }
                });
        },
        selectChangeds(val) {
            this.drid = val;
            console.log(val);
            this.$http
                .post("/api/roleController/selectGroupRole?did=" + val)
                .then(res => {
                    if (res.data.code === 200) {
                        this.soptionsr = res.data.data;
                        console.log("2");
                        this.selectDepartmentRoleDis(val);
                    }
                });
        },
        selectChangedss(val) {
            this.gid = val;
            this.selectDepartmentRoleDids(val);
        },
        // POST /userControllers/selectDepartmentRoleDids用户管理页面所有的信息,搜索条件部门、部长、组长、
        // 部门id did 部长ID:drid 组ID：gid
        selectDepartmentRoleDids(val) {
            this.$http
                .post(
                    "/api/userControllers/selectDepartmentRoleDids?cid=" +
                        this.users.cid +
                        "&drid=" +
                        this.drid +
                        "&did=" +
                        this.did +
                        "&gid=" +
                        val +
                        "&page=" +
                        this.currentpage +
                        "&size=" +
                        this.pagesize
                )
                .then(res => {
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                });
        },
        // POST /userControllers/selectDepartmentRoleDis用户管理页面所有的信息,搜索条件部门
        selectDepartmentRoleDis(val) {
            this.$http
                .post(
                    "/api/userControllers/selectDepartmentRoleDis?cid=" +
                        this.users.cid +
                        "&did=" +
                        val +
                        "&page=" +
                        this.currentpage +
                        "&size=" +
                        this.pagesize
                )
                .then(res => {
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                });
        },
        // POST /userControllers/selectDepartmentRoleDid用户管理页面所有的信息,搜索条件部门、姓名或手机号
        selectDepartmentRoleDid() {
            this.$http
                .post(
                    "/api/userControllers/selectDepartmentRoleDid?cid=" +
                        this.users.cid +
                        "&did=" +
                        this.did +
                        "&page=" +
                        this.currentpage +
                        "&size=" +
                        this.pagesize +
                        "&telephone=" +
                        this.state
                )
                .then(res => {
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                });
        },
        // POST /userControllers/selectDepartmentRole用户管理页面所有的信息,搜索条件部长、姓名或手机号
        selectDepartmentRolet() {
            this.$http
                .post(
                    "/api/userControllers/selectDepartmentRoleDid?cid=" +
                        this.users.cid +
                        "&did=" +
                        this.drid +
                        "&page=" +
                        this.currentpage +
                        "&size=" +
                        this.pagesize +
                        "&telephone=" +
                        this.state
                )
                .then(res => {
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                });
        },
        // POST /userControllers/selectDepartmentRoleDids用户管理页面所有的信息,搜索条件部门、部长、组长、姓名或手机号
        // 部门id did 部长ID:drid 组ID：gid
        selectDepartmentRole() {
            this.$http
                .post(
                    "/api/userControllers/selectDepartmentRole?cid=" +
                        this.users.cid +
                        "&drid=" +
                        this.drid +
                        "&did=" +
                        this.did +
                        "&gid=" +
                        this.gid +
                        "&page=" +
                        this.currentpage +
                        "&size=" +
                        this.pagesize +
                        "&telephone=" +
                        this.state
                )
                .then(res => {
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                });
        },
        handleIconClick() {
            var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
            if (!reg.test(this.state)) {
                if (this.did === "") {
                    this.$http
                        .post(
                            "/api/userControllers/selectDepartmentRoleName?cid=" +
                                this.users.cid +
                                "&page=" +
                                this.currentpage +
                                "&size=" +
                                this.pagesize +
                                "&name=" +
                                this.state
                        )
                        .then(res => {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total;
                        });
                } else if (this.drid === "") {
                    this.$http
                        .post(
                            "/api/userControllers/selectDepartmentRoleDid?cid=" +
                                this.users.cid +
                                "&did=" +
                                this.did +
                                "&page=" +
                                this.currentpage +
                                "&size=" +
                                this.pagesize +
                                "&name=" +
                                this.state
                        )
                        .then(res => {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total;
                        });
                } else if (this.gid === "") {
                    this.$http
                        .post(
                            "/api/userControllers/selectDepartmentRoleDid?cid=" +
                                this.users.cid +
                                "&did=" +
                                this.drid +
                                "&page=" +
                                this.currentpage +
                                "&size=" +
                                this.pagesize +
                                "&name=" +
                                this.state
                        )
                        .then(res => {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total;
                        });
                } else {
                    this.$http
                        .post(
                            "/api/userControllers/selectDepartmentRole?cid=" +
                                this.users.cid +
                                "&drid=" +
                                this.drid +
                                "&did=" +
                                this.did +
                                "&gid=" +
                                this.gid +
                                "&page=" +
                                this.currentpage +
                                "&size=" +
                                this.pagesize +
                                "&name=" +
                                this.state
                        )
                        .then(res => {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total;
                        });
                }
            } else {
                if (this.did === "") {
                    this.$http
                        .post(
                            "/api/userControllers/selectDepartmentRoleName?cid=" +
                                this.users.cid +
                                "&page=" +
                                this.currentpage +
                                "&size=" +
                                this.pagesize +
                                "&telephone=" +
                                this.state
                        )
                        .then(res => {
                            this.tableData = res.data.data.list;
                            this.total = res.data.data.total;
                        });
                } else if (this.drid === "") {
                    this.selectDepartmentRoleDid();
                } else if (this.gid === "") {
                    this.selectDepartmentRolet();
                } else {
                    this.selectDepartmentRole();
                }
            }
        },
        handleSizeChange(value) {
            this.pagesize = value;
            if (this.state === "") {
                this.init();
            } else {
                this.handleIconClick();
            }
        },
        handleCurrentChange(value) {
            this.currentpage = value;
            if (this.state === "") {
                this.init();
            } else {
                this.handleIconClick();
            }
        },
        handleSelectionChange(val) {
            console.log(val);
            this.multipleSelection = val;
            // this.handleIconClick()
        },
        deleteRow(row){
            this.$confirm("此操作将该账号移除本公司，是否离职?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "移除成功!"
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消移除"
                    });
                });
        }
    }
};
</script>

<style lang="scss">
.role {
    width: 98%;
    height: 100%;
    .index-left {
        float: left;
        width: 200px;
        height: 100%;
        overflow: hidden;
    }
    .fore-index-left {
        float: left;
        width: calc(100% - 250px);
    }
    .role-top {
        width: 100%;
        overflow: hidden;
        padding: 10px 0;
        border-bottom: 2px solid #bfbfbf;
    }
    .role-Choice {
        width: 20%;
        float: left;
        span {
            line-height: 30px;
        }
        .el-select {
            width: 60%;
        }
    }
}
</style>